var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 9,
    viewBox: "0 0 23 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2415 5.63963C21.9846 6.96699 17.0177 7.13826 11.1516 5.98217C5.28555 4.82608 0.746828 2.85645 1.00374 1.52909C1.26065 0.201728 6.22755 0.0732793 12.0936 1.18655C17.9169 2.34264 22.4984 4.35509 22.2415 5.63963V5.63963Z",
    fill: "url(#paint0_linear_1_286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1705 5.29721C20.9564 6.49612 16.5033 6.62457 11.2367 5.59693C5.92721 4.5693 1.85949 2.81376 2.07358 1.61485C2.33049 0.415945 6.78358 0.287485 12.0502 1.31512C17.3168 2.34275 21.4274 4.14112 21.1705 5.29721V5.29721Z",
    fill: "url(#paint1_linear_1_286)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0073 1.44358C6.86914 0.458765 2.45888 0.544402 2.07352 1.65767C2.07352 1.65767 2.07352 1.6434 2.07352 1.61485C2.33043 0.415945 6.78351 0.287485 12.0501 1.31512C17.3168 2.34275 21.4273 4.14112 21.1704 5.29721C21.1704 5.32576 21.1704 5.3543 21.1704 5.38284C21.2132 4.18393 17.1883 2.47122 12.0073 1.44358Z",
    fill: "#7E470D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.745619 2.85627L1.00253 1.52891C0.745619 2.85627 5.28434 4.8259 11.1504 5.98199C17.0165 7.13808 21.9834 6.96681 22.2403 5.63945L21.9834 6.96681C21.7265 8.29417 16.7596 8.46544 10.8935 7.30935C5.02743 6.15326 0.488711 4.18363 0.745619 2.85627V2.85627Z",
    fill: "url(#paint2_linear_1_286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_286",
    x1: 22.8838,
    y1: 9.23635,
    x2: 24.725,
    y2: 1.40064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_286",
    x1: 2.5874,
    y1: -8.23332,
    x2: 0.0183119,
    y2: 5.12594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_286",
    x1: -0.324834,
    y1: 6.45299,
    x2: 22.4544,
    y2: 10.8633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin10);
export default __webpack_public_path__ + "static/media/coin10.19134d904a47cf098f28450bc9405c37.svg";
export { ForwardRef as ReactComponent };